import React from "react";

const accentTop = {
  blue: "border-t-blue-500",
  cyan: "border-t-cyan-500",
  teal: "border-t-teal-500",
  indigo: "border-t-indigo-500",
  violet: "border-t-violet-500",
  magenta: "border-t-fuchsia-500",
};

const iconBg = {
  blue: "bg-blue-100 text-blue-600 shadow-blue-100",
  cyan: "bg-cyan-100 text-cyan-600 shadow-cyan-100",
  teal: "bg-teal-100 text-teal-600 shadow-teal-100",
  indigo: "bg-indigo-100 text-indigo-600 shadow-indigo-100",
  violet: "bg-violet-100 text-violet-600 shadow-violet-100",
  magenta: "bg-fuchsia-100 text-fuchsia-600 shadow-fuchsia-100",
};

const WhyAbscodCard = ({ icon: Icon, title, description, accent }) => {
  return (
    <article
      className={`group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 border-t-4 ${accentTop[accent]} bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:border-slate-300 hover:shadow-lg md:p-9`}
    >
      <span
        className={`flex h-14 w-14 items-center justify-center rounded-2xl shadow-[0_0_0_1px_rgba(255,255,255,0.5)] transition-shadow duration-300 group-hover:shadow-[0_0_24px_rgba(37,99,235,0.18)] ${iconBg[accent]}`}
      >
        <Icon className="h-6 w-6" strokeWidth={2} aria-hidden="true" />
      </span>
      <h3 className="mt-6 font-raleway text-xl font-bold text-slate-900">
        {title}
      </h3>
      <p className="mt-3 font-openSans text-base leading-relaxed text-slate-600">
        {description}
      </p>
    </article>
  );
};

export default WhyAbscodCard;
